module.exports = __webpack_public_path__ + "static/media/basic_hr_intro_screen.a9f569ce.png";